import {Component} from 'panel';

import {commaizeNumber} from 'common/util';
import {registerMPElement} from 'common/util/register-element';

import {generateMessage} from '../utils/message';
import {formatPercent} from '../utils/message/common';

import template from './index.jade';

class SmartHubViz extends Component {
  get config() {
    return {
      template,
      helpers: {
        isPositive: () => {
          return this.alert.expectedValue < this.alert.valueAtTimestamp;
        },
        getValues: () => {
          const min = Math.min(this.alert.expectedValue, this.alert.valueAtTimestamp);
          const max = Math.max(this.alert.expectedValue, this.alert.valueAtTimestamp);

          const lowerPercentage = Math.round((min / max) * 100);
          const higherPercentage = 100 - lowerPercentage;

          let formattedMin;
          let formattedMax;
          if (this.alert.isInsightsAnomaly()) {
            formattedMin = commaizeNumber(+min.toFixed(2));
            formattedMax = commaizeNumber(+max.toFixed(2));
          } else {
            formattedMin = formatPercent(min, 2);
            formattedMax = formatPercent(max, 2);
          }

          return {
            formattedMin,
            formattedMax,
            minPercentage: lowerPercentage,
            maxPercentage: higherPercentage,
          };
        },
        getMessage: () => {
          return generateMessage(this.alert.raw, {
            displayContext: `IN_REPORT`,
            subContext: `FORECAST`,
          });
        },
      },
    };
  }

  get alert() {
    return this.app.getAlert();
  }
}

export default registerMPElement(`mp-smart-hub-viz`, SmartHubViz);
